import { Flex } from "@highoutput/ui-components";
import type { FC } from "react";
import Navbar from "~/components/navbar";

import Footer from "../landing/v2/footer";
import CampaignHeader from "./campaign-header";
import CaseStudyContent from "./case-study";
import CampaignContent from "./content";
import Faqs from "./faqs";

const mock = {
  faqs: [
    {
      id: 1,
      question: "What is Coaching?",
      answer: [
        `Coaching is a process of one-on-one support provided by a professional coach who will help you identify your goals, develop strategies, and create action plans to achieve success. Coaches are trained to ask insightful questions, provide feedback, and offer guidance to help navigate challenges and reach your full potential.`,
        `Some common agendas that people discuss with coaches include career transitions, improving communication and leadership skills, enhancing productivity and time management, building confidence and self-esteem, and achieving work-life balance. Coaches will help you explore your strengths and weaknesses, identify areas for growth, and develop personalized plans to achieve your goals. By working with a coach, you can gain clarity, motivation, and support to overcome obstacles and succeed in your personal and professional lives.`,
      ],
    },
    {
      id: 2,
      question: "What should they expect during the 2-day free coaching session?",
      answer: [
        `During the 2-day free coaching session, participants should expect to gain valuable insights into the key areas where they can make progress toward their professional aspirations. They can expect to receive guidance on how to develop actionable plans to overcome these obstacles and to experience the benefits of working with a coach.`,
      ],
    },
    {
      id: 3,
      question: "What will they get during the 2-day free coaching session?",
      answer: [
        `By the end of the program, you'll walk away with a clear understanding of where you are in your career journey and how to get to where you want to be. During the coaching sessions, you'll work with our coaches to identify your goals and develop a plan of action to achieve them. Plus, you'll receive a personalized report of your coaching assessments and action plans three days after completing the 2-day free coaching sessions.`,
      ],
    },
    {
      id: 4,
      question: "What are the benefits of Coaching?",
      answer: [
        `The benefits of coaching include increased self-awareness, improved decision-making, greater confidence, enhanced communication skills, and a clearer sense of direction. Coaching can help individuals overcome limiting beliefs and behaviors, leading to more significant progress towards their personal and professional goals.`,
      ],
    },
    {
      id: 5,
      question: "Scope and limitations of the 2-day free coaching campaign?",
      answer: [
        `The scope of the 2-day free coaching campaign is to provide participants with a taste of what coaching can do for them. It is an opportunity to experience coaching and gain valuable insights, but it is not intended to provide long-term coaching or address complex issues. The campaign is limited to two days, and participants should expect to receive a condensed version of the coaching experience.`,
        `If you feel like two days won't be enough to fully address your needs, we invite you to enroll in our full coaching program. Our experienced coaches are dedicated to helping you achieve your goals, and our program provides long-term coaching and support to address complex issues and provide ongoing guidance. Don't miss out on this opportunity to invest in yourself and take the first step towards unlocking your full potential.`,
      ],
    },
  ],
};

const CampaignPage: FC = () => (
  <Flex minHeight="100vh" direction="column" fontFamily="Inter">
    <Navbar />

    <CampaignHeader />
    <CampaignContent />
    <CaseStudyContent />
    <Faqs data={mock.faqs} />

    <Footer cta />
  </Flex>
);
export default CampaignPage;
